import React, { useCallback, useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import ListHeading from "../../common/RDTListHeading/ListHeading";
import SubHeaderComponent from "../../common/RDTSubHeaderComponent/SubHeaderComponent";
import Images from "../../../utils/images";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GetColmn } from "../../common/CustomColumn/customize_column";
import useWindowDimensions from "../../../utils/getHeightWidth";
import { changeTitle } from "../../../state/slices/header";
import { useDispatch } from "react-redux";
import GetCapabilities from "../../../utils/getCapabilities.js";
import { Slide, Fade } from "@mui/material";
import {
  delayTime,
  fadedelayTime,
  slideDirection,
} from "../../../utils/transitionEffectParams";
import { getCloudConfigurations, deleteCloudConfigurations, scanCloudConfiguration, getCloudConfigurationById, addCloudConfiguration, pollCloudConfigurationStatus } from "../../../api/cloudDiscovery";
import { useNavigate, useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack";
import GeneralButton from "../../common/SaveButton/GeneralButton";
import CustomModal from "../../common/CustomModal/CustomModal";
import ShowAlert from "../../common/ShowAlert/ShowAlert";
import { showError, showSuccess } from "../../../utils/showMessage";
import plus from "../../../images/plus.svg";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Select from "react-select";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiEdit2, FiRefreshCw } from "react-icons/fi";
import { LuScanLine } from "react-icons/lu";
import { RiDeleteBin5Line, RiFileCopyLine } from "react-icons/ri";
import { RiScanLine } from "react-icons/ri";
import { BsInfoCircle } from "react-icons/bs";
import { Tooltip, Skeleton, IconButton } from "@mui/material";
import DataTableSkeleton from "../../common/Skeletons/DataTableSkeleton";
import "./CloudConfiguration.scss";
import { useReactSelectTheme } from "../../../utils/useReactSelectTheme";
import { loadColumnPreference } from "../../common/CustomColumn/customize_column";
import { PutColumnPreference } from "../../../api/column_pref";
import { useTranslation } from "react-i18next";
const ActionComponent = ({ navigate }) => {
  const { t } = useTranslation();
  const my_capabilities = GetCapabilities();
  const isCapable = my_capabilities[0];

  if (!isCapable || !isCapable.cloud_discovery || !isCapable.cloud_discovery.add) {
    return null;
  }

  return (
    <Stack direction="row" spacing={2} className="py-3">
      <GeneralButton
        onClickEvent={() =>
          navigate(
            "/dashboard/discovery/cloudconfiguration/select-plateform/add-configuration"
          )
        }
        variant="outlined"
        startIcon={
          <LazyLoadImage src={plus} alt="icon" id="center-blueShadow" />
        }
        value={t("cloudDiscovery.addConfiguration")}
        size="large"
      />
    </Stack>
  );
};

function CloudConfiguration() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();
  const navigate = useNavigate();
  const location = useLocation();
  const my_capabilities = GetCapabilities();
  const isCapable = my_capabilities[0];
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterBy, setFilterBy] = useState("");
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [pending, setPending] = useState(true);
  const [slideChecked, setSlideChecked] = useState(false);
  const [colCount, setColCount] = useState(null);
  const tableHeightWithData = height - 220 + "px";
  const tableHeightEmpty = height - 180 + "px";
  const [datatableHeight, setDatatableHeight] = useState(tableHeightEmpty);
  const { styles: selectStyles, theme: selectTheme } = useReactSelectTheme();

  const pages_url = "dashboard/discovery/cloud_configuration";
  const customizeColumnDict = {
    "cloudDiscovery.type": true,
    "cloudDiscovery.region": true,
    "cloudDiscovery.status": true,
  };
  const [checkedStateDict, setCheckedStateDict] = useState(customizeColumnDict);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [toBeDeleted, setToBeDeleted] = useState([]);
  const [colName, setColName] = useState(null);
  const [action, setAction] = useState("");
  const actionOptions = [{ label: t("common.delete"), value: "delete" }];
  const [openScanModal, setOpenScanModal] = useState(false);
  const [scanMessage, setScanMessage] = useState("");
  const [scanHeading, setScanHeading] = useState("");
  const [openDuplicateModal, setOpenDuplicateModal] = useState(false);
  const [configToDuplicate, setConfigToDuplicate] = useState(null);
  const [duplicateName, setDuplicateName] = useState("");
  const [duplicateRegions, setDuplicateRegions] = useState(null);
  const [pollingRowId, setPollingRowId] = useState(null);
  const [preferenceLoaded, setPreferenceLoaded] = useState(false);

  const awsRegionNames = useMemo(() => ({
    "us-east-1": t("cloudDiscovery.regions.us-east-1"),
    "us-east-2": t("cloudDiscovery.regions.us-east-2"),
    "us-west-1": t("cloudDiscovery.regions.us-west-1"),
    "us-west-2": t("cloudDiscovery.regions.us-west-2"),
    "ap-south-1": t("cloudDiscovery.regions.ap-south-1"),
    "ap-southeast-1": t("cloudDiscovery.regions.ap-southeast-1"),
    "ap-southeast-2": t("cloudDiscovery.regions.ap-southeast-2"),
    "ap-northeast-1": t("cloudDiscovery.regions.ap-northeast-1"),
    "eu-central-1": t("cloudDiscovery.regions.eu-central-1"),
    "eu-west-1": t("cloudDiscovery.regions.eu-west-1"),
    "eu-west-2": t("cloudDiscovery.regions.eu-west-2"),
  }), [t]);

  const awsRegions = [
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ap-northeast-1",
    "eu-central-1",
    "eu-west-1",
    "eu-west-2",
  ];

  const filterOptions = [
    { label: t("cloudDiscovery.configName"), value: "configuration_name" },
    { label: t("cloudDiscovery.service"), value: "service" },
    { label: t("cloudDiscovery.type"), value: "type" },
    { label: t("cloudDiscovery.region"), value: "region" },
    { label: t("common.status"), value: "status" },
  ];

  const getStatus = (row) => {
    const errors = row.permission_errors || [];
    const services = Array.isArray(row.service) ? row.service : (row.service ? [row.service] : []);
    const regions = Array.isArray(row.region) ? row.region : (row.region ? [row.region] : []);
    const totalChecks = services.length * regions.length;
    
    if (totalChecks === 0) {
      return { status: "inactive", errors: [] };
    }
    
    if (errors.length === 0) {
      return { status: "active", errors: [] };
    }
    
    if (errors.length >= totalChecks) {
      return { status: "inactive", errors };
    }
    
    return { status: "partially active", errors };
  };

  useEffect(() => {
    document.title = t("cloudDiscovery.cloudDiscovery");
    dispatch(changeTitle("Discovery"));
    setSlideChecked(true);
    
    if (!isCapable?.cloud_discovery?.view) {
      navigate("/dashboard");
    }
  }, [isCapable, navigate, dispatch]);

  const getList = async ({ page, rowsPerPage, search, filterBy }) => {
    const { data } = await getCloudConfigurations({
      page,
      page_size: rowsPerPage,
      search,
      filter_by: filterBy,
    });
    if (data) {
      setList(data.results);
      setFilteredData(data.results);
      setTotal(data.count);
    }
    setPending(false);
  };

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleAction = async () => {
    if (action === "delete") {
      handleDelete(null);
    }
  };

  const handleDelete = (rows) => {
    const rowsToDelete = rows ? rows : selectedRows;
    setToBeDeleted(rowsToDelete);
    setColName(rowsToDelete.map((item) => item.configuration_name || item.platform));
    setOpenDeleteModal(true);
  };

  const handleDeleteAction = async () => {
    try {
      const ids = toBeDeleted.map((r) => r.id);
      const { data, error } = await deleteCloudConfigurations({ ids });
      if (data) {
        showSuccess(data.message);
        setPending(true);
        await getList({ page, rowsPerPage, search, filterBy });
      }
      if (error) showError(error);
    } catch (e) {
      showError(t("cloudDiscovery.messages.deleteFailed"), t("cloudDiscovery.messages.unableToDelete"));
    } finally {
      setSelectedRows([]);
      setToggleCleared((t) => !t);
      setOpenDeleteModal(false);
      setToBeDeleted([]);
      setColName(null);
    }
  };

  const handleDuplicate = (row) => {
    setConfigToDuplicate(row);
    const regions = Array.isArray(row.region) ? row.region : (row.region ? [row.region] : []);
    const regionValue = regions.length > 0 ? regions[0] : null;
    if (regionValue) {
      const regionCode = typeof regionValue === "string" ? regionValue : (regionValue.value || regionValue);
      const regionName = awsRegionNames[regionCode] || regionCode;
      setDuplicateRegions({
        label: `${regionCode} - ${regionName}`,
        value: regionCode
      });
    } else {
      setDuplicateRegions(null);
    }
    
    const fullName = row.configuration_name || row.name || t('cloudDiscovery.configuration');
    let baseName = fullName;
    
    if (regionValue && fullName.endsWith(`-${regionValue}`)) {
      baseName = fullName.substring(0, fullName.length - regionValue.length - 1);
    } else {
      const sortedRegions = [...awsRegions].sort((a, b) => b.length - a.length);
      for (const region of sortedRegions) {
        if (fullName.endsWith(`-${region}`)) {
          baseName = fullName.substring(0, fullName.length - region.length - 1);
          break;
        }
      }
    }
    
    if (!baseName || baseName.trim() === '') {
      baseName = t("cloudDiscovery.configuration");
    }
    
    setConfigToDuplicate({ ...row, _baseName: baseName });
    
    if (regionValue) {
      setDuplicateName(`${baseName}-${regionValue}`);
    } else {
      setDuplicateName(baseName);
    }
    setOpenDuplicateModal(true);
  };

  const handleRegionChange = (selectedOption) => {
    const selected = selectedOption || null;
    setDuplicateRegions(selected);
    
    let baseName = configToDuplicate?._baseName;
    
    if (!baseName) {
      const currentName = duplicateName || configToDuplicate?.configuration_name || configToDuplicate?.name || t('cloudDiscovery.configuration');
      if (selected && currentName.endsWith(`-${selected.value}`)) {
        baseName = currentName.substring(0, currentName.length - selected.value.length - 1);
      } else {
        baseName = currentName;
        for (const region of awsRegions) {
          if (currentName.endsWith(`-${region}`)) {
            baseName = currentName.substring(0, currentName.length - region.length - 1);
            break;
          }
        }
      }
      if (configToDuplicate) {
        setConfigToDuplicate({ ...configToDuplicate, _baseName: baseName });
      }
    }
    
    if (selected) {
      const regionSuffix = selected.value;
      setDuplicateName(`${baseName}-${regionSuffix}`);
    } else {
      setDuplicateName(baseName);
    }
  };

  const handleDuplicateAction = async () => {
    if (!duplicateName.trim()) {
      showError(t("cloudDiscovery.configurationNameRequired"));
      return;
    }

    if (!duplicateRegions) {
      showError(t("cloudDiscovery.pleaseSelectRegion"));
      return;
    }

    try {
      setPending(true);
      const { data: configData, error: fetchError } = await getCloudConfigurationById({ config_id: configToDuplicate.id });
      
      if (fetchError || !configData) {
        showError(fetchError?.message?.[0] || t("cloudDiscovery.failedToFetchConfigurationDetails"));
        setPending(false);
        return;
      }

      const duplicatePayload = {
        configuration_name: duplicateName.trim(),
        platform: configData.platform || configData.provider_type?.toLowerCase() || "aws",
        what_to_scan: configData.what_to_scan || configData.service || configData.services || [],
        aws_region: duplicateRegions.value,
        aws_access_key_id: configData.aws_access_key_id || "",
        aws_secret_access_key: configData.aws_secret_access_key || "",
      };

      const { data, error } = await addCloudConfiguration(duplicatePayload);
      
      if (data) {
        showSuccess(t("cloudDiscovery.configurationDuplicatedSuccessfully"));
        setPending(true);
        await getList({ page, rowsPerPage, search, filterBy });
        
        const newConfigId = data?.config?.id || data?.id;
        if (newConfigId && (configToDuplicate.provider_type === 'AWS' || configToDuplicate.platform === 'aws' || configToDuplicate.type === 'AWS')) {
          pollCloudConfigurationStatus({ config_id: newConfigId })
            .then(() => {
              getList({ page, rowsPerPage, search, filterBy });
            })
            .catch((pollError) => {
              console.error("Failed to poll status after duplicate:", pollError);
            });
        }
        
        setOpenDuplicateModal(false);
        setConfigToDuplicate(null);
        setDuplicateName("");
        setDuplicateRegions(null);
      } else {
        showError(error?.errors?.message?.[0] || (typeof error === 'string' ? error : null) || t("cloudDiscovery.failedToDuplicateConfiguration"));
      }
    } catch (e) {
      showError(t("cloudDiscovery.duplicateFailed"), t("cloudDiscovery.unableToDuplicateConfiguration"));
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    loadColumnPreference(setCheckedStateDict, pages_url, checkedStateDict, rowsPerPage, setRowsPerPage, setPreferenceLoaded);
  }, []);
  useEffect(() => {
    if (!preferenceLoaded) return;
    setPending(true);
    getList({ page, rowsPerPage, search, filterBy });
  }, [page, rowsPerPage, preferenceLoaded]);

  useEffect(() => {
    const handleConfigUpdate = () => {
      setPending(true);
      getList({ page, rowsPerPage, search, filterBy });
    };

    window.addEventListener('cloudConfigUpdated', handleConfigUpdate);
    
    if (location.state?.shouldRefresh) {
      navigate(location.pathname, { replace: true, state: {} });
      setTimeout(() => {
        setPending(true);
        getList({ page, rowsPerPage, search, filterBy });
      }, 100);
    }

    return () => {
      window.removeEventListener('cloudConfigUpdated', handleConfigUpdate);
    };
  }, [location, page, rowsPerPage, search, filterBy, navigate]);

  useEffect(() => {
    const div = document.getElementById("cloudDatatableDivId");
    if (div && list && list.length > 0) {
      div.style.height = tableHeightWithData;
      setDatatableHeight(tableHeightWithData);
    } else {
      setDatatableHeight(tableHeightEmpty);
    }
  }, [list]);

  useEffect(() => {
    if (!list) return;
    const s = search.replaceAll(/[\\*()+[?]/g, "");
    const result = list.filter((o) => {
      const serviceVal = Array.isArray(o.service) ? o.service.join(", ") : o.service || "";
      const regionVal = Array.isArray(o.region) ? o.region.join(", ") : o.region || "";
      if (!filterBy) {
        return (
            (o.configuration_name || o.name || "").toLowerCase().includes(s.toLowerCase()) ||
          (o.platform || "").toLowerCase().includes(s.toLowerCase()) ||
          serviceVal.toLowerCase().includes(s.toLowerCase()) ||
          regionVal.toLowerCase().includes(s.toLowerCase()) ||
            (o.type || o.provider_type || "").toLowerCase().includes(s.toLowerCase())
        );
      }
      const val = Array.isArray(o[filterBy]) ? o[filterBy].join(", ") : o[filterBy] || "";
      return val.toLowerCase().includes(s.toLowerCase());
    });
    setFilteredData(result);
  }, [search, list, filterBy]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPending(true);
    getList({ page, rowsPerPage, search, filterBy });
  };

  const handlePageChange = (p) => setPage(p);
  const handlePerRowsChange = async (newPerPage) => {
    setPage(1);
    setRowsPerPage(newPerPage);
    await PutColumnPreference(checkedStateDict, pages_url, newPerPage);
  };

  const handleScan = async (row) => {
    try {
      await scanCloudConfiguration({ id: row.id });
      showSuccess(t("cloudDiscovery.scanInitiated"));
      navigate(`/dashboard/discovery/cloudconfiguration/history/${row.id}`);
    } catch (err) {
      showError(t("cloudDiscovery.scanStartError"));
    }
    await getList({ page, rowsPerPage, search, filterBy });
  };

  const handleEdit = (row) => {
    navigate(`/dashboard/discovery/cloudconfiguration/edit-cloudconfiguration/${row.id}?provider=${row.platform}`);
  };

  const handleViewHistory = (row) => {
    navigate(`/dashboard/discovery/cloudconfiguration/history/${row.id}`);
  };

  const handlePollStatus = async (row) => {
    try {
      setPollingRowId(row.id);
      
      const { data, error } = await pollCloudConfigurationStatus({ config_id: row.id });
      if (data) {
        await getList({ page, rowsPerPage, search, filterBy });
        setTimeout(() => {
          setPollingRowId(null);
        }, 300);
      } else {
        showError(error?.message?.[0] || t("cloudDiscovery.messages.failedToPollStatus"));
        setPollingRowId(null);
      }
    } catch (err) {
      showError(t("cloudDiscovery.messages.somethingWentWrongPolling"));
      setPollingRowId(null);
    }
  };

  const columns = useMemo(() => [
    {
      name: t("cloudDiscovery.configName"),
      selector: (row) => row.configuration_name || row.name || "-",
      grow: 1,
      sortable: true,
    },
    { name: t("cloudDiscovery.service"),
      cell: (row) => {
        const services = Array.isArray(row.service) ? row.service : (row.service ? [row.service] : []);
        
        if (services.length === 0) {
          return <span>-</span>;
        }

        return (
          <div className="cloud-discovery-tags-container">
            {services.map((service, index) => (
              <span key={index} className="cloud-discovery-tag">
                {service}
              </span>
            ))}
          </div>
        );
      },
      sortable: true,
      grow: 1
    },
    { name: t("cloudDiscovery.type"), 
      selector: (row) => row.type || row.provider_type || row.platform || "-", 
      grow: 1, 
      sortable: true, 
      omit: checkedStateDict["cloudDiscovery.type"] === false },
    {
      name: t("cloudDiscovery.region"),
      cell: (row) => {
        const regions = Array.isArray(row.region) ? row.region : (row.region ? [row.region] : []);
        
        if (regions.length === 0) {
          return <span>-</span>;
        }

        return <span>{regions.join(", ")}</span>;
      },
      selector: (row) => {
        const regions = Array.isArray(row.region) ? row.region : (row.region ? [row.region] : []);
        return regions.join(", ") || "-";
      },
      sortable: true,
      wrap: false,
      grow: 1,
      omit: checkedStateDict["cloudDiscovery.region"] === false,
    },
    {
      name: t("cloudDiscovery.status"),
          cell: (row) => {
        if (pollingRowId === row.id) {
          return (
            <div className="d-flex align-items-center gap-2">
              <Skeleton 
                variant="rounded" 
                width={100} 
                height={24} 
                sx={{ borderRadius: "4px" }}
              />
            </div>
          );
        }

        const { status, errors } = getStatus(row);
        const statusKey = status === "partially active" ? "partiallyActive" : status;
        const statusText = t(`cloudDiscovery.${statusKey}`);
        const statusClass = 
          status === "active" ? "cloud-discovery-status-active" : 
          status === "partially active" ? "cloud-discovery-status-partially-active" : 
          "cloud-discovery-status-inactive";
        
        const statusColor = 
          status === "active" ? "#03BA82" : 
          status === "partially active" ? "#F2C700" : 
          "#F56A3F";
        
        const tooltipContent = errors.length > 0 ? (
          <div className="py-1" style={{ maxWidth: "300px" }}>
            <strong className="d-block mb-2">{t("cloudDiscovery.permissionErrors")}</strong>
            <ul className="m-0 ps-4 small">
              {errors.map((error, index) => (
                <li key={index} className="mb-1">
                  {error}
                </li>
              ))}
            </ul>
          </div>
        ) : t("cloudDiscovery.allPermissionChecksPassed");
        
        return (
          <div className="d-flex align-items-center justify-content-between w-100">
            <span 
              className={`cloud-discovery-status-badge ${statusClass}`}
            >
              {statusText}
            </span>
            <div className="d-flex align-items-center gap-2 ms-auto">
              {errors.length > 0 && (
                <Tooltip 
                  title={tooltipContent} 
                  arrow 
                  placement="top"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <span className="d-inline-flex align-items-center">
                    <BsInfoCircle 
                      className="cloud-discovery-info-icon"
                    />
                  </span>
                </Tooltip>
              )}
              <Tooltip title={t("cloudDiscovery.refreshStatus")} arrow placement="top">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePollStatus(row);
                  }}
                  sx={{
                    padding: "4px",
                    "&:hover": {
                      backgroundColor: "rgba(81, 119, 255, 0.1)",
                    },
                  }}
                >
                  <FiRefreshCw 
                    size={16} 
                    style={{ color: "#5177FF" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
          },
          sortable: true,
      grow: 1,
      omit: checkedStateDict["cloudDiscovery.status"] === false,
        },

    {
      name: t("common.action"),
      cell: (row) => {
        const { status } = getStatus(row);
        const isInactive = status === "inactive";
        const my_capabilities = GetCapabilities();
        const isCapable = my_capabilities[0];
        
        const hasEdit = isCapable?.cloud_discovery?.edit;
        const hasStartScan = isCapable?.cloud_discovery?.start_scan;
        const hasViewHistory = isCapable?.cloud_discovery?.view_scan_history;
        const hasAdd = isCapable?.cloud_discovery?.add;
        const hasDelete = isCapable?.cloud_discovery?.delete;
        
        if (!hasEdit && !hasStartScan && !hasViewHistory && !hasAdd && !hasDelete) {
          return null;
        }
        
        return (
          <Nav>
            <NavDropdown
              id="nav-dropdown-cloud-config"
              title={<BsThreeDotsVertical className="text-black" />}
              menuVariant="primary"
            >
              {hasEdit && (
                <NavDropdown.Item onClick={() => handleEdit(row)}>
                  <FiEdit2 size={12} className="mx-2" width="13" height="13" />
                  {t("common.edit")}
                </NavDropdown.Item>
              )}
              {hasStartScan && (
                <NavDropdown.Item
                  onClick={() => !isInactive && handleScan(row)}
                  disabled={isInactive}
                  style={{
                    opacity: isInactive ? 0.5 : 1,
                    cursor: isInactive ? 'not-allowed' : 'pointer'
                  }}
                >
                  <LuScanLine className="mx-2" width="13" height="13" />
                  {t("cloudDiscovery.scan")}
                </NavDropdown.Item>
              )}
              {hasViewHistory && (
                <NavDropdown.Item onClick={() => handleViewHistory(row)}>
                  <RiScanLine alt="history" className="mx-2" width="13" height="13" /> {t("cloudDiscovery.viewScanHistory")}
                </NavDropdown.Item>
              )}
              {hasAdd && (
                <NavDropdown.Item onClick={() => handleDuplicate(row)}>
                  <RiFileCopyLine alt="duplicate" className="mx-2" width="13" height="13" /> {t("cloudDiscovery.duplicate")}
                </NavDropdown.Item>
              )}
              {hasDelete && (
                <NavDropdown.Item onClick={() => handleDelete([row])}>
                  <RiDeleteBin5Line alt="delete" className="mx-2" width="13" height="13" /> {t("common.delete")}
                </NavDropdown.Item>
              )}
            </NavDropdown>
          </Nav>
        );
      },
    },
  ], [checkedStateDict, pollingRowId]);


  return (
    <>
      {pending && list.length === 0 ? (
        <DataTableSkeleton rowCount={7} columnCount={6} />
      ) : (
    <Slide timeout={delayTime} direction={slideDirection} in={slideChecked}>
      <Fade timeout={fadedelayTime} in={slideChecked}>
        <div className="main_content_container p-3 mx-auto w-100">
          <div
            id="cloudDatatableDivId"
            className="position-relative bg-white"
            style={{ height: datatableHeight }}
          >
                  <DataTable
                    title={
                <ListHeading
                  dataTableHeadingText={t("cloudDiscovery.cloudConfigurations")}
                  dataTableHeadingIcon={Images.NetworkAnalyzer}
                />
              }
              actions={<ActionComponent navigate={navigate} />}
              columns={columns}
              data={filteredData}
              className="rdt_container"
              progressPending={pending}
              progressComponent={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                  <div style={{ color: '#5177ff' }} className="la-line-scale-pulse-out-rapid la-3x">
                    <div className="rounded"></div>
                    <div className="rounded"></div>
                    <div className="rounded"></div>
                    <div className="rounded"></div>
                    <div className="rounded"></div>
                  </div>
                </div>
              }
              fixedHeader
              paginationPerPage={rowsPerPage}
              paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
              pagination
              paginationServer
              paginationTotalRows={total}
              highlightOnHover
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              selectableRows
              selectableRowsVisibleOnly
              selectableRowsHighlight
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleCleared}
              subHeader
              subHeaderComponent={
                <SubHeaderComponent
                  filterBy={filterBy}
                  setFilterBy={setFilterBy}
                  filterOptions={filterOptions}
                  search={search}
                  setSearch={setSearch}
                  handleSearch={handleSearch}
                  placeholder={t("cloudDiscovery.cloudConfigurations")}
                  pages_url={pages_url}
                  checkedStateDict={checkedStateDict}
                  setCheckedStateDict={setCheckedStateDict}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  action={action}
                  setAction={setAction}
                  handleAction={handleAction}
                  actionOptions={actionOptions}
                  selectedRows={selectedRows}
                />
              }
              subHeaderAlign="center"
            />
            {colName && (
              <CustomModal
                open={openDeleteModal}
                handleClose={() => setOpenDeleteModal(false)}
              >
                <ShowAlert
                  setOpenAlert={setOpenDeleteModal}
                  handleAlertAction={handleDeleteAction}
                  colName={colName}
                  alertMsg={t("cloudDiscovery.belowConfigurationsWillBeDeleted")}
                  headingMsg={t("cloudDiscovery.deleteCloudConfiguration")}
                />
              </CustomModal>
            )}
            {openScanModal && (
              <CustomModal
                open={openScanModal}
                handleClose={() => setOpenScanModal(false)}
              >
                <ShowAlert
                  setOpenAlert={setOpenScanModal}
                  alertMsg={scanMessage}
                  headingMsg={scanHeading}
                  handleAlertAction={() => setOpenScanModal(false)}
                  showCancel={false}
                  colName={[]}
                />
              </CustomModal>
            )}
            {openDuplicateModal && (
              <CustomModal
                open={openDuplicateModal}
                handleClose={() => {
                  setOpenDuplicateModal(false);
                  setConfigToDuplicate(null);
                  setDuplicateName("");
                  setDuplicateRegions(null);
                }}
                width="50%"
              >
                <div className="p-3">
                  <h5 className="mb-4">{t("cloudDiscovery.duplicateConfiguration")}</h5>
                  <div className="mb-3">
                    <label className="form-label">{t("cloudDiscovery.regionName")}</label>
                    <Select
                      name="duplicateRegions"
                      options={awsRegions.map((r) => ({ 
                        label: `${r} - ${awsRegionNames[r] || r}`, 
                        value: r 
                      }))}
                      value={duplicateRegions}
                      onChange={handleRegionChange}
                      placeholder={t("cloudDiscovery.selectRegion")}
                      className="user_input_field"
                      menuPlacement="bottom"
                      isClearable
                      styles={selectStyles}
                      theme={selectTheme}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">{t("cloudDiscovery.configurationName")}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={duplicateName}
                      onChange={(e) => {
                        const newName = e.target.value;
                        setDuplicateName(newName);
                        if (configToDuplicate && duplicateRegions) {
                          const regionValue = duplicateRegions.value;
                          if (newName.endsWith(`-${regionValue}`)) {
                            const extractedBase = newName.substring(0, newName.length - regionValue.length - 1);
                            setConfigToDuplicate({ ...configToDuplicate, _baseName: extractedBase });
                          } else {
                            let extractedBase = newName;
                            for (const region of awsRegions) {
                              if (newName.endsWith(`-${region}`)) {
                                extractedBase = newName.substring(0, newName.length - region.length - 1);
                                break;
                              }
                            }
                            setConfigToDuplicate({ ...configToDuplicate, _baseName: extractedBase });
                          }
                        } else if (configToDuplicate) {
                          setConfigToDuplicate({ ...configToDuplicate, _baseName: newName });
                        }
                      }}
                      placeholder={t("cloudDiscovery.enterConfigurationName")}
                      autoFocus
                    />
                    <small className="form-text text-muted">
                      {t("cloudDiscovery.nameAutoUpdatedByRegion")}
                    </small>
                  </div>
                  <div className="d-flex justify-content-end gap-2 mt-4">
                    <GeneralButton
                      onClickEvent={() => {
                        setOpenDuplicateModal(false);
                        setConfigToDuplicate(null);
                        setDuplicateName("");
                        setDuplicateRegions(null);
                      }}
                      value={t("common.cancel")}
                      color="#505050"
                      variant="outlined"
                      size="large"
                    />
                    <GeneralButton
                      onClickEvent={handleDuplicateAction}
                      value={t("cloudDiscovery.duplicate")}
                      variant="contained"
                      size="large"
                    />
                  </div>
                </div>
              </CustomModal>
            )}
            </div>
        </div>
      </Fade>
    </Slide>
      )}
    </>
  );
}

export default CloudConfiguration;
